export const getApiUrl = () => {
    // For local/testing: use same host and port as the page is served from
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.protocol === 'file:') {
        // Use the current origin (includes port) for Docker test environment
        return window.location.origin;
    }
    // Force clean origin for staging to avoid Basic Auth credential leakage in fetch
    if (window.location.hostname.includes('staging')) {
        return window.location.origin;
    }
    return ''; // Production (Traefik) (Fallthrough)
};

export const API_URL = getApiUrl();

export const getImageUrl = (imagePath) => {
    if (!imagePath) return 'https://placehold.co/400x300/e2e8f0/94a3b8?text=Kein+Bild';
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        // Fix Mixed Content: Upgrade HTTP to HTTPS if on invalid protocol
        // Skip protocol upgrade for localhost (runtime detection)
        const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        if (window.location.protocol === 'https:' && imagePath.startsWith('http://') && !isLocalhost) {
            return imagePath.replace('http://', 'https://');
        }
        return imagePath;
    }
    if (imagePath.startsWith('/')) {
        return API_URL ? `${API_URL}${imagePath}` : imagePath;
    }
    return API_URL ? `${API_URL}/${imagePath}` : `/${imagePath}`;
};
